import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { projectsSelector } from '../../../../../store';
import { HookFormProvider } from '../../../../UI/HookForm/Provider';
import { ProjectSourcesForm } from './ProjectSourcesForm';

//Validation Schema needs
const validationSchema = Yup.object({
  sources: Yup.array().of(
    Yup.object({
      name: Yup.string().required('Required'),
      amount: Yup.number().required('Required').min(0, 'Amount must be 0 or greater'),
    })
  ),
});

function ProjectSources({ handleProgress }: { handleProgress: (type: string) => void }) {
  const { Project } = useSelector(projectsSelector);
  const ProjectSourcesState = Project.ProjectBudget;

  return (
    <HookFormProvider resolver={yupResolver(validationSchema) as any} defaultValues={ProjectSourcesState} mode='all'>
      <ProjectSourcesForm ProjectSourcesState={ProjectSourcesState} handleProgress={handleProgress} />
    </HookFormProvider>
  );
}

export default ProjectSources;
